import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Button1 = (props: Props) => {
  const className = `font-jost-regular text-base ${mapStylesFromProps(props)}`
  return <span className={className}>{props.children}</span>
}

export default Button1
